/* eslint-disable no-empty-pattern */
/* eslint-disable array-bracket-newline */
/**
 * Implements a page header bar
 */
import { Link } from 'react-router-dom';

import Image from '../../../atoms/Image';
import logo from '../../../assets/images/kattana_logo.svg';
import search from '../../../assets/images/search_grey.svg';
import notification from '../../../assets/images/notification_grey.svg';
import list from '../../../assets/images/list.svg';
import Text from '../../../atoms/Text';

import './styles.scss';

interface IHeaderProps {
  onToggleSidebar: () => void;
  onToggleSearch: () => void;
  onToggleNews: () => void;
}

const HeaderMobile = ({
  onToggleSidebar,
  onToggleSearch,
  onToggleNews,
}: IHeaderProps) => {
  return (
    <div className='global_header_mobile'>
      <div className='global_header_mobile__left_menu'>
        <div className='global_header_mobile__left_menu__logo_box'>
          <Link to='/'>
            <Image size='m' src={logo} />
          </Link>
        </div>
        <div
          className='global_header_mobile__left_menu__search'
          onClick={onToggleSearch}
        >
          <div className='global_header_mobile__left_menu__search__icon'>
            <Image size='m' src={search} />
          </div>
          <div className='global_header_mobile__left_menu__search__placeholder'>
            <Text
              size={12}
              className='global_header_mobile__left_menu__search__placeholder__text'
            >
              Search...
            </Text>
          </div>
        </div>
      </div>
      <div className='global_header_mobile__right_menu'>
        <div className='global_header_mobile__right_menu__notification'>
          <Image size='m' src={notification} onClick={onToggleNews} />
        </div>
        <Image size='m' src={list} onClick={onToggleSidebar} />
      </div>
    </div>
  );
};

export default HeaderMobile;
